import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getCodeList = store => store[NAME].codeList;
export const getAccessTypeList = store => store[NAME].accessTypeList;
export const getProcessList = store => store[NAME].processList;
export const getUserMenuList = store => store[NAME].userMenuList;
export const getDetailTableList = store => store[NAME].detailTableList;
